// Web has no hardware back button. Provide no-op equivalents so shared code that
// imports back-press (Android double-press-to-exit) compiles and runs on web.
export const subBackPress = (_cb: () => boolean) => ({ remove: () => {} })

export const doublePressToExitHandler = () => false
